import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { imagesApi } from '../../api/images';
import { queryKeys } from '../queryClient';

export function useImages(category?: string) {
  return useQuery({ queryKey: queryKeys.images(category), queryFn: () => imagesApi.list(category) });
}

export function useUploadImage() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ file, category }: { file: File; category?: string }) => imagesApi.upload(file, category),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['images'] }),
  });
}

export function useDeleteImage() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (fileName: string) => imagesApi.remove(fileName),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['images'] }),
  });
}
